<template>
  <div v-if="value?.length">
    <div
      v-for="(productType, index) in value"
      :key="index"
      class="my-5 max-w-40 break-normal whitespace-nowrap"
    >
      <div
        :class="{
          'inline-block bg-gray-100 px-1 py-0.5': productType.length > 1,
        }"
      >
        {{ productType }}
      </div>
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import type { FinancialProduct } from "@/models/common";

defineProps<{
  value?: FinancialProduct[];
}>();
</script>
